module.exports = __webpack_public_path__ + "img/ai-bind-cel.dcb01aae.png";